import * as React from 'react'
import { Link, RelativeRoutingType } from 'react-router-dom'

interface UnstyledLinkProps{
  children: React.ReactElement
  to: string,
  relative?: RelativeRoutingType
  
}

const UnstyledLink : React.FC<UnstyledLinkProps> = (props) => {
  return (
    <Link relative={props.relative} to={ props.to } style={{ color: 'inherit', textDecoration: 'none' }}>
        {props.children}
    </Link>
  )
}

export default UnstyledLink